import React from 'react'
import SideMenuMonitoring, {menuItemsMonitoring} from '../../components/SideMenuMonitoring/SideMenuMonitoring'


import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import '../DocumentationTeamHealth/DocTeamHealth.css'

const DemoVideo = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
            <div style={{marginTop :  "30px"}} >

           <SideMenuMonitoring
            onCollapse={(inactive) => {
              //console.log(inactive);
              setInactive(inactive);
            }}
          />
  
          <div className={`container ${inactive ? "inactive" : ""}`}>
            {/* improvememt, not recorded in video, its just looping through menuItemsMonitoring
            instead of hard coding all the routes */}
            {menuItemsMonitoring.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
                <p>Application monitoring</p> 
                <h3>video demonstration</h3>
                <p>you can find in this video a demonstration how to use our app. if you have any questions please send us an email.</p>

               
              <p>
               <a href="https://www.youtube.com/watch?v=PipV5Tp4eEA" target="_blank"> See demo video </a>
               </p>

  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
          </div>
          
      </>
      
    )
  }

export default DemoVideo
